import React from 'react';

import { styled } from 'core/styles';
import { MarketName } from 'components';

export function AreaName({ name }: { name: string }) {
  return (
    <NameContainer>
      <MarketName tooltip="disable" marketName={name} withSpaces />
    </NameContainer>
  );
}

const NameContainer = styled('div')({
  maxWidth: '100%',
  textAlign: 'center',
  fontSize: 'inherit',
  letterSpacing: '-0.25px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
